import React from 'react';
import {
  Map,
  Circle,
  GoogleApiWrapper,
} from 'google-maps-react';

const LoadingContainer = () => (
  <div>Carregando...</div>
);

const MapContainer = ({ google, coords, distance }) => (
  <div style={{
    width: '100%', height: '250px', position: 'relative', border: '3px solid #D9D9D9',
  }}
  >
    <Map
      google={google}
      initialCenter={coords}
      zoom={11}
      scrollwheel={false}
      // draggable={false}
      // zoomControl={false}
      mapTypeControl={false}
      streetViewControl={false}
      fullscreenControl={false}
      scaleControl={false}
      panControl={false}
      rotateControl={false}
    >
      <Circle
        radius={distance * 1000}
        center={coords}
        strokeColor="transparent"
        strokeOpacity={0}
        strokeWeight={5}
        fillColor="#FF0000"
        fillOpacity={0.2}
      />
    </Map>
  </div>
);

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAV8wcLKojRBtM1NhARI30SgpWM3O5TCmw',
  LoadingContainer,
})(MapContainer);
